/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RuntimeResourceUsage,
  RuntimeResourceUsage$inboundSchema,
  RuntimeResourceUsage$Outbound,
  RuntimeResourceUsage$outboundSchema,
} from "./runtimeresourceusage.js";

export type CommandResult = {
  sessionId: string;
  command: string;
  args?: Array<string> | undefined;
  cwd: string;
  stdout?: string | undefined;
  stderr?: string | undefined;
  exitCode: number;
  filesChanged?: Array<string> | undefined;
  resourceUsage?: RuntimeResourceUsage | null | undefined;
};

/** @internal */
export const CommandResult$inboundSchema: z.ZodType<
  CommandResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  command: z.string(),
  args: z.array(z.string()).optional(),
  cwd: z.string(),
  stdout: z.string().default(""),
  stderr: z.string().default(""),
  exit_code: z.number().int(),
  files_changed: z.array(z.string()).optional(),
  resource_usage: z.nullable(RuntimeResourceUsage$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "exit_code": "exitCode",
    "files_changed": "filesChanged",
    "resource_usage": "resourceUsage",
  });
});
/** @internal */
export type CommandResult$Outbound = {
  session_id: string;
  command: string;
  args?: Array<string> | undefined;
  cwd: string;
  stdout: string;
  stderr: string;
  exit_code: number;
  files_changed?: Array<string> | undefined;
  resource_usage?: RuntimeResourceUsage$Outbound | null | undefined;
};

/** @internal */
export const CommandResult$outboundSchema: z.ZodType<
  CommandResult$Outbound,
  z.ZodTypeDef,
  CommandResult
> = z.object({
  sessionId: z.string(),
  command: z.string(),
  args: z.array(z.string()).optional(),
  cwd: z.string(),
  stdout: z.string().default(""),
  stderr: z.string().default(""),
  exitCode: z.number().int(),
  filesChanged: z.array(z.string()).optional(),
  resourceUsage: z.nullable(RuntimeResourceUsage$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    exitCode: "exit_code",
    filesChanged: "files_changed",
    resourceUsage: "resource_usage",
  });
});

export function commandResultToJSON(commandResult: CommandResult): string {
  return JSON.stringify(CommandResult$outboundSchema.parse(commandResult));
}
export function commandResultFromJSON(
  jsonString: string,
): SafeParseResult<CommandResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CommandResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CommandResult' from JSON`,
  );
}
